import React from 'react'
import RequestPasswordReset from '@apps/accounts/src/features/RequestPasswordReset'
import Page from '@apps/accounts/src/components/Page'
import { useTranslation } from 'react-i18next'

const ResetPasswordPage = () => {
  const { t } = useTranslation()

  return (
    <Page title={t('request-password-reset.title')}>
      <Page.Alert />

      <RequestPasswordReset />
    </Page>
  )
}

export default ResetPasswordPage
